module.exports = __webpack_public_path__ + "img/jiomart.4b1d4697.png";